/*
 * VAKHRA — archive register hover preview
 * Extracted from the inline script previously embedded in
 * templates/page.archive.json (and a stale duplicate in page.json).
 *
 * Uses event delegation on document rather than per-row binding, so it
 * survives Horizon soft-navigation and theme-editor section re-renders,
 * and binds exactly once. Desktop only; disabled under 750px.
 */
(function () {
  if (window.matchMedia('(max-width: 749px)').matches) return;

  var preview = null;
  var img = null;

  function ensurePreview() {
    if (!preview || !document.body.contains(preview)) {
      preview = document.getElementById('vakhraPreview');
      img = preview ? preview.querySelector('img') : null;
    }
    return !!preview;
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    var row = t.closest ? t.closest('.vakhra-archive__row') : null;
    if (!row || !ensurePreview()) return;
    if (row.dataset.preview) {
      img.src = row.dataset.preview;
      preview.classList.add('is-visible');
    }
  });

  document.addEventListener('mousemove', function (e) {
    if (!preview || !preview.classList.contains('is-visible')) return;
    var t = e.target;
    var row = t.closest ? t.closest('.vakhra-archive__row') : null;
    if (!row) return;
    preview.style.left = (e.clientX + 24) + 'px';
    preview.style.top = (e.clientY - 120) + 'px';
  });

  document.addEventListener('mouseout', function (e) {
    if (!preview) return;
    var t = e.target;
    var row = t.closest ? t.closest('.vakhra-archive__row') : null;
    if (!row) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('.vakhra-archive__row') === row) return;
    preview.classList.remove('is-visible');
  });
})();
